// The static pitch markings (outline, halfway line, centre circle, boxes, spots, arcs)
// as JSX, from the kit's pitchMarkings() data — the legacy pitchMarkupSvg() string. Same
// elements in the same order; lines/boxes/arcs carry fill="none" exactly as the legacy
// markup does (spots are filled by CSS). Rendered inside a module's own `.pitch-frame` <g>.

import { pitchMarkings } from "../engines/event-map-kit.js";

const MARKINGS = pitchMarkings();

export function PitchMarkings() {
  return (
    <>
      {MARKINGS.map((m, i) => {
        switch (m.tag) {
          case "rect":
            return <rect key={i} className={m.className} x={m.x} y={m.y} width={m.width} height={m.height} fill="none" />;
          case "line":
            return <line key={i} className={m.className} x1={m.x1} y1={m.y1} x2={m.x2} y2={m.y2} />;
          case "circle":
            return m.className === "pitch-line" ? (
              <circle key={i} className={m.className} cx={m.cx} cy={m.cy} r={m.r} fill="none" />
            ) : (
              <circle key={i} className={m.className} cx={m.cx} cy={m.cy} r={m.r} />
            );
          case "path":
            return <path key={i} className={m.className} d={m.d} fill="none" />;
        }
      })}
    </>
  );
}
